import { findComposePlugins } from '../plugins/ComposePlugins';
import { orchestrator } from 'satcheljs';
import ComposePlugins from '../plugins/ComposePlugins';
import { ComposeViewState } from 'owa-mail-compose-store';
import onAccessibilityCheckerClickFromMailTip from '../actions/onAccessibilityCheckerClickFromMailTip';

/**
 * Orchestrator which opens the accessibility checker in the flex pane
 */
export default orchestrator(onAccessibilityCheckerClickFromMailTip, actionMessage => {
    const viewState: ComposeViewState = actionMessage.viewState;
    const plugins: ComposePlugins = findComposePlugins(viewState);

    if (plugins && plugins.accChecker) {
        const accCheckerViewState = viewState.accChecker;
        const accCheckerPlugin = plugins.accChecker;
        if (!(accCheckerViewState && accCheckerViewState.isOpen)) {
            accCheckerPlugin.addOnImportedCallback(plugin => plugin.openChecker());
            accCheckerPlugin.getPlugin();
        }
    }
});
